import { render, staticRenderFns } from "./Register2FA.vue?vue&type=template&id=2b9a02f8"
import script from "./Register2FA.vue?vue&type=script&lang=js"
export * from "./Register2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports